import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
// import { useHistory } from 'react-router-dom';

function useManageChapterQuiz({ courseID }) {
  // const history = useHistory();
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addQuiz({ chapterID, ...data } = {}) {
    return privateFetch.post(`/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes`, data);
  }

  function updateQuiz({ chapterID, quizID, ...data } = {}) {
    return privateFetch.put(
      `/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/${quizID}`,
      data
    );
  }

  function deleteQuiz({ chapterID, quizID } = {}) {
    return privateFetch.delete(
      `/v1/admin/course/${courseID}/chapters/${chapterID}/quizzes/${quizID}`
    );
  }

  function manageChapterQuiz({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateQuiz(data);
    }

    if (type === 'DELETE') {
      return deleteQuiz(data);
    }

    return addQuiz(data);
  }

  return useMutation(manageChapterQuiz, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters-quizzes');
    },
  });
}

export default useManageChapterQuiz;
